
import EmployeeAvatar from '@/components/employee/EmployeeAvatar.vue';
import Checkbox from '@/components/inputs/Checkbox.vue';
import { userCan } from '@/lib/permission/userCan';
import { Entity } from '@/lib/realtime/RealtimeEntity';
import { realtimeQuery } from '@/lib/realtime/weak/realtimeFunctions';
import { getEntityName } from '@/util/entityFunctions';
import { isCurrentEmployee } from '@/util/permissionFunctions';
import { PropType } from 'vue';
import { Employee } from '../../../api/v1';

/**
 * Default component to list employees. This has lots of properties to customise.
 *
 * `checkbox` is used to add a checkbox selection
 */
export default {
  name: 'EmployeeListItem',

  components: {
    Checkbox,
    EmployeeAvatar,
  },

  props: {
    employee: {
      type: Object as PropType<Employee>,
      required: true,
    },

    showAvatar: {
      type: Boolean,
      default: true,
    },

    showStatus: {
      type: Boolean,
      default: false,
    },

    checkbox: {
      type: Boolean,
      default: false,
    },

    showJobRoles: {
      type: Boolean,
      default: false,
    },

    size: {
      type: String,
      default: 'small',
      validator: (prop) =>
        ['small', 'normal', 'large', 'xLarge'].includes(prop),
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    values: {
      type: Array,
      default: () => [],
    },

    highlightSelf: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      userCan,
      activeJobRoles: realtimeQuery(Entity.JobRole).whereActive().fetch(),
    };
  },

  computed: {
    listEmployeeJobRoles() {
      const { jobRoleIds } = this.employee;
      if (jobRoleIds.length) {
        return (
          jobRoleIds
            .map((id) => getEntityName(id, this.activeJobRoles.data))
            // Filter out empty fallback strings
            .filter((j) => !!j)
            .join(', ')
        );
      }
      return this.$t('label.noJobRolesAssigned');
    },
  },

  methods: { isCurrentEmployee },
};
